<template>
	<div>
		<div
			class="mt-4 w-full flex justify-between space-x-60"
			v-if="!isLoadingDfs"
		>
			<div class="flex w-2/5">
				<div>
					<div class="flex flex-col mt-5">
						<h6>
							Suggestion de mots-clés - {{ totalChoosenKeywords.length }}/10
							mots-clés sélectionnéess
						</h6>
						<div class="vx-row mt-4">
							<vs-chip
								:key="index"
								closable
								@click="removechoosenKeywords(index)"
								v-for="(keyword, index) in choosenKeywords"
							>
								{{ keyword.keyword }}
							</vs-chip>
							<vs-chip
								:key="index"
								closable
								@click="removeChoosenKeywordsByAi(index)"
								v-for="(keyword, index) in choosenKeywordsByAi"
							>
								{{ keyword.keyword }}
							</vs-chip>
							<!-- <vs-textarea v-model="stringBrands" height="200px" rows="10" /> -->
						</div>
						<div class="flex mt-5">
							<!-- Sliding Input with Transition -->
							<transition name="slide-left">
								<div v-if="showInput">
									<vs-input v-model="newKeyword" />
								</div>
							</transition>
							<!-- Button -->
							<vs-button @click="toggleInput" class="ml-2"
								>{{ showInput ? "Enregister" : "Mots-clés +" }}
							</vs-button>
						</div>
					</div>
					<vs-table
						:data="internalKeywordList"
						max-items="100"
						pagination
						multiple
						search
						ref="ref-keywords-ideas-table"
						v-model="choosenKeywords"
						class="mt-5"
						:key="keywordsTableKey"
						noDataText="Aucun(e) mots-clés."
					>
						<template slot="header"> Suggestion de mots-clés </template>
						<template slot="thead">
							<vs-th style="pointer-events: auto" sort-key="keyword"
								>Mots-clés</vs-th
							>
							<!-- Madame ou Monsieur -->
							<vs-th style="pointer-events: auto" sort-key="cpc">CPC</vs-th>
							<vs-th style="pointer-events: auto" sort-key="search_volume"
								>Volume</vs-th
							>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="tr.keyword">{{ tr.keyword }}</vs-td>
								<!-- Madame ou Monsieur -->
								<!--<vs-td v-if="lead_account_manager == tr"><vs-button @click="deleteAccountManagerLead(tr.id)" class="mx-2">Supprimer</vs-button><span>Lead</span></vs-td>-->
								<vs-td :data="tr.cpc" class="text-right"
									>{{
										!isNaN(tr.cpc)
											? convertInternationalNumberToFrenchCurrency(tr.cpc)
											: tr.cpc
									}}
								</vs-td>
								<vs-td :data="tr.search_volume" class="text-right">
									{{
										tr.search_volume && !isNaN(tr.search_volume)
											? tr.search_volume.toLocaleString("fr-FR")
											: tr.search_volume
									}}</vs-td
								>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</div>
			<div class="flex w-1/5"></div>
			<div class="flex w-2/5">
				<ProspectionSuggestionAIBox
					:runAiSuggestions="runAiSuggestions"
					:url="mainUrl"
					ref="refKeywordsIdeasAiTable"
					@click-choose-keyword="updateChooseKeywordsAi($event)"
				/>
			</div>
		</div>
		<div v-else>
			<circular-loader />
		</div>
	</div>
</template>

<script>
import store from "@/store/store";
import dbFieldConvertorMixin from "../../mixins/dbFieldConvertorMixin";
import ProspectionSuggestionAIBox from "../../views/pages/prospection/ProspectionSuggestionAIBox.vue";
import CircularLoader from "../widgets/loader/CircularLoader.vue";

export default {
	name: "ProspectSecondPageUrlTable",
	props: {
		mainUrl: {
			type: String,
			default: "",
		},
		keywordList: {
			type: Array,
			required: true,
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		isLoadingDfs: {
			type: Boolean,
			default: false,
		},
	},
	components: { ProspectionSuggestionAIBox, CircularLoader },
	mixins: [dbFieldConvertorMixin],
	created() {
		this.fetchPrompts();
	},
	data() {
		return {
			choosenKeywords: [],
			choosenKeywordsByAi: [],
			keywordsTableKey: 0,
			newKeyword: "",
			internalKeywordList: [...this.keywordList],
			showInput: false,
			isLoading: false,
			// Your data properties here
			runAiSuggestions: false,
			prompt: "",
		};
	},
	computed: {
		newProspects() {
			return store.state.newProspects;
		},
		oldProspects() {
			return store.state.oldProspects;
		},
		totalChoosenKeywords() {
			return this.choosenKeywords.concat(this.choosenKeywordsByAi);
		},
	},
	watch: {
		choosenKeywordsByAi: function (data) {
			this.$emit("updated-top-keywords", [
				...this.choosenKeywords,
				...this.choosenKeywordsByAi,
			]);
			// console.log("Keywords updated", this.newProspects);
		},
		choosenKeywords: function (data) {
			if (this.choosenKeywords.length <= 10) {
				this.$emit("updated-top-keywords", [
					...this.choosenKeywords,
					...this.choosenKeywordsByAi,
				]);
			} else {
				// limiting to only 10 keyowrds
				this.choosenKeywords.pop();
				this.$vs.notify({
					title: "Attention",
					text: "Vous ne pouvez pas choisir plus de 10 mots-clés",
					color: "warning",
				});
			}
			// console.log("Keywords updated", this.newProspects);
		},
		// Your watch properties here
	},
	methods: {
		removechoosenKeywords(index) {
			this.choosenKeywords.splice(index, 1); // Remove the keyword at the given index
		},
		removeChoosenKeywordsByAi(index) {
			this.$refs.refKeywordsIdeasAiTable.removeChooseKeyword(index);
		},
		updateChooseKeywordsAi(val) {
			try {
				if (this.totalChoosenKeywords.length < 10)
					this.choosenKeywordsByAi = val;
				else
					this.$vs.notify({
						title: "Attention",
						text: "Vous ne pouvez pas choisir plus de 10 mots-clés",
						color: "warning",
					});
			} catch (err) {
				console.log(err);
			}
		},
		toggleInput() {
			if (!this.showInput) {
				this.showInput = !this.showInput; // Toggle the visibility of the input
			} else {
				if (this.newKeyword.length > 0) {
					this.internalKeywordList.unshift({
						keyword: this.newKeyword,
						cpc: "-",
						search_volume: "-",
					});
					this.newKeyword = "";
					// Remove this line:
					// this.keywordsTableKey++;
				}
			}
		},
		// Your methods here
		validateAllFields() {
			console.log("ProspectSecondPageUrlTable validateAllFields");
			if (this.totalChoosenKeywords.length == 0) {
				return false;
			} else {
				return true;
			}
		},
	},
	created() {
		this.runAiSuggestions = true;
		// Code to run when the component is created
		try {
			// check if the component is in edit mode
			if (this.$props.isEdit) {
				// need to add old keywords to the choosen keywords to display with new keywords
				this.oldProspects.keywordList.forEach((ele, index, array) => {
					let foundOldKeywords = this.internalKeywordList.find(
						(value, index, array) => value.keyword == ele.keyword
					);
					// add old keywords to the choosen keywords with new data from the keyword list
					if (foundOldKeywords) {
						this.choosenKeywords.push(foundOldKeywords);
					} else {
						// if not found , add anywasy to the keyword list with old data
						this.internalKeywordList.unshift(ele);
						this.choosenKeywords.unshift(ele);
					}
				});
				this.keywordsTableKey++;
			}
		} catch (e) {
			console.log("ERROR keyowrd:", e);
		}
	},
};
</script>

<style scoped>
/* Your component styles here */
/* Slide transition */
/* Slide from left transition */
.slide-left-enter-active,
.slide-left-leave-active {
	transition: all 0.5s ease;
}
.slide-left-enter,
.slide-left-leave-to {
	transform: translateX(-100%);
	opacity: 0;
}
</style>